import React, { useState, useEffect, createContext } from 'react'
import axios from 'axios'
import { useCookies } from 'react-cookie'
import { Base64 } from 'js-base64'

export const UserContext = createContext()

export const redirectToAuthWithFrom = () => {
  window.location.href = `${process.env.REACT_APP_AUTH_PAGE}?from=${encodeURIComponent(window.location.href)}`
}

export const UserProvider = (props) => {
  const [cookies] = useCookies(['8egma2jfs9mu'])
  const [user, setUser] = useState({})
  const [isValid, setIsValid] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    const apiToken = cookies['8egma2jfs9mu'] || process.env.REACT_APP_API_TOKEN
    if (apiToken) {
      const decodedAuth = Base64.decode(apiToken)
      axios.defaults.headers.common['Authorization'] = `Bearer ${decodedAuth}`
    }
    const getUser = async () => {
      try {
        const {
          data: { data: user },
        } = await axios.post(`${process.env.REACT_APP_API}/user`)
        setUser(user)
        setIsValid(!!user.email && !!user.first_name && !!user.last_name && !!user.phone_no)
        setIsLoading(false)
      } catch (e) {
        setUser({})
        setIsValid(false)
        setIsLoading(false)
      }
    }
    getUser()
  }, [])
  return (
    <UserContext.Provider
      value={{
        isUserValid: isValid,
        user,
        isLoading,
      }}
    >
      {props.children}
    </UserContext.Provider>
  )
}
